var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 474,
    viewBox: "0 0 227 474",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M-183.963 357.089C-219.15 345.456 -229.895 300.924 -203.885 274.524L50.9728 15.8514C78.4951 -12.0829 125.997 1.09424 135.195 39.215L225.115 411.873C234.313 449.993 198.048 483.383 160.815 471.074L-183.963 357.089Z",
    fill: "url(#paint0_linear_15_146)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15_146",
    x1: -260.35,
    y1: 331.835,
    x2: 326.99,
    y2: 190.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#685296"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523958,
    stopColor: "#DCCBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76875,
    stopColor: "#C0A2FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon2);
export default __webpack_public_path__ + "static/media/Polygon2.2c7b68a60ce7ea6d7bd892b6ebe52f28.svg";
export { ForwardRef as ReactComponent };